export enum EnvironmentType {
  Default = '',
  Local = 'local',
  Dev = 'dev',
  PreProd = 'pre',
  Prod = 'prod',
  GCloudVar = '##ENV##'
}

export interface EnvironmentModel {
  apiKey: string,
  production: boolean,
  environmentType: EnvironmentType,
  imagebaseUrl: string,
  auth0: {
    domain: string,
    clientId: string,
    httpInterceptor: {
      allowedList: string[]
    },
    authorizationParams: {
      redirect_uri: string,
      audience: string,
      responseType: string,
      scope: string,
    }
  }
}
